export default function PasswordInput({ password, confirmPassword, onPasswordChange, onConfirmPasswordChange, autoFocus = false }) {
  const inputStyle = {
    width: '100%',
    padding: '10px',
    background: '#1a1a1c',
    border: '1px solid #3a3a3e',
    borderRadius: '4px',
    color: '#e8e6e3',
    fontSize: '14px',
    boxSizing: 'border-box',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '6px',
    fontSize: '13px',
    color: '#999',
  };

  const hintStyle = {
    marginTop: '4px',
    fontSize: '11px',
    color: '#666',
  };

  const passwordsMatch = confirmPassword === '' || password === confirmPassword;
  const passwordLongEnough = password.length >= 8 || password.length === 0;

  return (
    <>
      <div>
        <label style={labelStyle}>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          required
          autoFocus={autoFocus}
          style={inputStyle}
        />
        <div style={hintStyle}>
          {!passwordLongEnough && (
            <span style={{ color: '#d4726a' }}>Must be at least 8 characters</span>
          )}
          {passwordLongEnough && password.length > 0 && (
            <span style={{ color: '#7eb5a6' }}>✓ Password length OK</span>
          )}
          {password.length === 0 && (
            <span>Must be at least 8 characters</span>
          )}
        </div>
      </div>

      <div>
        <label style={labelStyle}>Confirm Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => onConfirmPasswordChange(e.target.value)}
          required
          style={inputStyle}
        />
        <div style={hintStyle}>
          {!passwordsMatch && confirmPassword.length > 0 && (
            <span style={{ color: '#d4726a' }}>Passwords do not match</span>
          )}
          {passwordsMatch && confirmPassword.length > 0 && (
            <span style={{ color: '#7eb5a6' }}>✓ Passwords match</span>
          )}
        </div>
      </div>
    </>
  );
}
